@if (loading) {
    <app-loader-dot-pulse aria-label="Loading..." title="Loading..." size="small" />
}
<img
    [src]="src"
    [attr.alt]="alt"
    [attr.title]="title"
    [attr.color]="'red'"
    [ngStyle]="{ width: width, height: height }"
    [class.hidden]="loading || failed"
    (load)="onLoad()"
    (error)="onError()"
/>
